import request from './request';
/**
 *  获取线索列表
 */
export function getClueList(params) {
    return request('/accident-clue/pay-stat', {
        method: 'GET',
        params,
    });
}
/**
 *  查询明细
 */
export function getClueDetail(params) {
    return request('/accident-clue/pay-stat/detail', {
        method: 'GET',
        params,
    });
}
/**
 *  线索预约回店
 */
export function clueBookingOrder(id, params) {
    return request(`/accident-clue/${id}/booking-order`, {
        method: 'POST',
        params,
    });
}
/**
 *  快速查询线索通用数据（通过线索创建工单时使用）
 */
export function getClueBasicData(id) {
    return request(`/accident-clue/${id}/general`, {
        method: 'GET',
    });
}
